import { message } from "antd";
export var CommonResponse = {
  success: function success(res) {
    var status = res.status,
      data = res.data;
    if (status === 200) {
      var _ref = data || {},
        requestMessage = _ref.message,
        success = _ref.success;
      if (success === true) {
        return Promise.resolve(data.data);
      } else {
        message.error("".concat(requestMessage));
        return Promise.reject("".concat(requestMessage));
      }
    } else {
      message.error('系统繁忙，请稍后再试');
      return Promise.reject('系统繁忙，请稍后再试');
    }
  },
  error: function error() {
    message.error('系统繁忙，请稍后再试');
    return Promise.reject('系统繁忙，请稍后再试');
  }
};